import { Redo2, Undo2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { DocumentEditorApi } from "./useDocumentEditor";

const IS_MAC =
  typeof navigator !== "undefined" && navigator.userAgent.includes("Mac");
const UNDO_SHORTCUT = IS_MAC ? "⌘Z" : "Ctrl+Z";
const REDO_SHORTCUT = IS_MAC ? "⇧⌘Z" : "Ctrl+Shift+Z";

interface DocumentEditorToolbarProps {
  /** The editor whose history the toolbar drives. */
  editor: DocumentEditorApi;
}

/**
 * The editor header's undo/redo controls, shared by the per-quote and template
 * editors.
 * @param editor - The editor whose history the toolbar drives
 * @returns The toolbar button group
 */
export function DocumentEditorToolbar({ editor }: DocumentEditorToolbarProps) {
  return (
    <div className="flex shrink-0 items-center gap-1 border-l pl-3">
      <Button
        variant="ghost"
        size="sm"
        disabled={!editor.canUndo}
        onClick={editor.undo}
        title={`Undo (${UNDO_SHORTCUT})`}
        aria-label="Undo"
      >
        <Undo2 className="size-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        disabled={!editor.canRedo}
        onClick={editor.redo}
        title={`Redo (${REDO_SHORTCUT})`}
        aria-label="Redo"
      >
        <Redo2 className="size-4" />
      </Button>
    </div>
  );
}
